/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { IUserParentalRatingResponseModel } from "../models";

export class UserParentalRatingService {
  get url(): string {
    return "/v2";
  }

  public getParentalRating = (
    referenceId: string
  ): Promise<IUserParentalRatingResponseModel> =>
    httpService.request<IUserParentalRatingResponseModel>({
      axiosConfig: {
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/config/${referenceId}`,
    });
}
